import { PermissionKey } from "../constants/permissionCode";
import { TrackingOutputModuleName } from "../constants/trackingConstants";

export const MenuItem = [
  { label: "ADMINISTRATION", separator: true, module: "DASHBOARD" },
  // {
  //   label: "Company",
  //   separator: false,
  //   module: "COMPANY",
  //   route: "/administration/company",
  // },
  {
    label: "COMPANY BRANCH",
    separator: false,
    module: "COMPANY BRANCH",
    route: "/administration/company-branch",
    imgsrc: "assets/img/branch.png",
  },
  {
    label: "OBJECT MODULE",
    separator: false,
    module: "OBJECT MODULE",
    route: "/administration/object-module",
    imgsrc: "assets/img/module.png",
  },

  { label: "USER MANAGEMENT", separator: true },
  {
    label: "USER",
    separator: false,
    module: "USER",
    route: "/user-management/user",
    imgsrc: "assets/img/user.png",
  },
  {
    label: "ROLE",
    separator: false,
    module: "ROLE",
    route: "/user-management/role",
    imgsrc: "assets/img/role.png",
  },
  {
    label: "EMPLOYEE",
    separator: false,
    module: "EMPLOYEE",
    route: "/user-management/employee",
    imgsrc: "assets/img/employee.png",
  },
  { label: "MASTERS", separator: true },
  {
    label: "SYS CONFIGURATION",
    separator: false,
    imgsrc: "assets/img/system_icon.png",
    children: [
      {
        label: "WhatsApp Configuration",
        separator: false,
        module: "WHATSAPP CONFIGURATION",
        route: "/masters/system-configuration/whatsapp-alert-configuration"
      },
      {
        label: "Email Configuration",
        separator: false,
        module: "EMAIL CONFIGURATION",
        route: "/masters/system-configuration/email-alert-configuration"
      }
    ]
  },
  {
    label: "PLACES",
    separator: false,
    module : "PLACES",
    imgsrc: "assets/img/location.png",
    children: [
      {
        label: "Destination",
        separator: false,
        module: "DESTINATION",
        route: "/masters/places/destination",
      },
      {
        label: "Country",
        separator: false,
        module: "COUNTRY",
        route: "/masters/places/country",
      },
      // {
      //   label: "Sector",
      //   separator: false,
      //   module: "SECTOR",
      //   route: "/masters/places/sector",
      // },
    ],
  },
  {
    label: "OPERATIONAL",
    iconClasses: "",
    separator: false,
    module : "OPERATIONAL",
    imgsrc: "assets/img/operational.png",
    children: [
      {
        label: "Client",
        route: "/masters/operational/client",
        module: "CLIENT",
      },
      {
        label: "Vessel",
        route: "/masters/operational/vessel",
        module: "VESSEL",
      },
      /*{ label: 'Consortium', route: '/masters/operational/consortium' },
            { label: 'Role', route: '/masters/operational/role' },
            { label: 'Country', route: '/masters/operational/country' }*/
      {
        label: "Container",
        route: "/masters/operational/container",
        module: "CONTAINER",
      },
      {
        label: "Container Margin",
        separator: false,
        route: "/masters/operational/container-margin",
        module: "CONTAINER MARGIN",
      },
      {
        label: "Equipment",
        route: "/masters/operational/equipment",
        module: "EQUIPMENT TYPE",
      },  
      {
        label: "Equipment Size",
        route: "/masters/operational/equipment-size",
        module: "EQUIPMENT SIZE",
      },
      {
        label: "Package",
        route: "/masters/operational/package",
        module: "PACKAGE",
      },
      {
        label: "Consortium",
        route: "/masters/operational/consortium",
        module: "CONSORTIUM",
      },
      {
        label: "Commodity",
        route: "/masters/operational/commodity",
        module: "COMMODITY",
      },
      {
        label: "Vessel Voyage",
        route: "/masters/operational/vessel-voyage",
        module: "VESSEL VOYAGE",
      },
      {
        label: "Unit",
        route: "/masters/operational/unit",
        module: "UNIT",
      },
      {
        label: "Liner Service",
        route: "/masters/operational/liner-service",
        module: "LINER SERVICE",
      },
      {
        label: "Liner Origin Service",
        route: "/masters/operational/liner-origin-service",
        module: "LINER ORIGIN SERVICE",
      },
      {
        label: "Customer Service Requirement",
        route: "/masters/operational/customer-service-requirement",
        module: "CUSTOMER SERVICE REQUIREMENT",
      },
      {
        label: "Country Wise Service Requirement",
        route: "/masters/operational/country-wise-service-requirement",
        module: "COUNTRY WISE SERVICE REQUIREMENT",
      },
      {
        label: "Weekly Consol Planning",
        route: "/masters/operational/weekly-consol-planning",
        module: "WEEKLY CONSOL PLANNING",
      },
      {
        label: "Share Consol Planning",
        route: "/masters/operational/share-weekly-consol-planning",
        module: "SHARE WEEKLY CONSOL PLANNING",
      },
      {
        label: "Service",
        route: "/masters/operational/service",
        module: "SERVICE",
      },
    ],
  },
  {
    label: "ACCOUNTS",
    iconClasses: "",
    separator: false,
    module : "ACCOUNTS",
    imgsrc: "assets/img/accounts.png",
    children: [
      { label: "Bank", route: "/masters/accounts/bank",module :"BANK" },
      // { label: "Business Segment", route: "/masters/accounts/business-segment",module :"BUSINESS SEGMENT" },
      { label: "Map Charge to Business Segment", route: "/masters/accounts/map-charge-to-business-segment",module :"MAP CHARGE TO BUSINESS SEGMENT" },
      { label: "Charge", route: "/masters/accounts/charge",module :"CHARGE" },
      // { label: 'TDS', route: '/masters/accounts/tds' },
      {
        label: "Map Income To Business Segment",
        route: "/masters/accounts/map-income-to-business-segment",
        module: "MAP INCOME TO BUSINESS SEGMENT"
      },
      { label: 'GST', route: '/masters/accounts/gst',module:"GST" },
      // { label: 'VERTICAL', route: '/masters/accounts/vertical',module:"VERTICAL" }
    ],
  },
  {
    label: "PEOPLES",
    separator: false,
    module : "PEOPLES",
    imgsrc: "assets/img/people.png",
    children: [
      {
        label: "Direct Entity",
        separator: false,
        module: "DIRECT ENTITY",
        route: "/masters/peoples/direct-entity",
      },
      {
        label: "Entity",
        separator: false,
        module: "ENTITY",
        route: "/masters/peoples/entity",
      }
    ],
  },
  {
    label: "CHARGES",
    separator: false,
    module: "CHARGES",
    imgsrc: "assets/img/tariff.png",
    children: [
      {
        label: "Standard Origin Charge",
        separator: false,
        module: PermissionKey.STANDARD_ORIGIN_CHARGE,
        route: "/masters/charges/standard-origin-charge",
      },
      {
        label: "Standard Destination Charge",
        separator: false,
        module: PermissionKey.STANDARD_DESTINATION_CHARGE,
        route: "/masters/charges/standard-destination-charge",
      },
      {
        label: "Customer Wise Destination Charge",
        route: "/masters/charges/customer-destination-charge",
        module: "CUSTOMER WISE DESTINATION CHARGE"
      },
      {
        label: "Customer Wise Origin Charge",
        separator: false,
        module: "CUSTOMER ORIGIN CHARGE",
        route: "/masters/charges/customer-origin-charge"
      },
      {
        label: "Country Wise Other Charges",
        separator: false,
        module: PermissionKey.COUNTRY_WISE_OTHER_CHARGES,
        route: "/masters/charges/country-wise-other-charges"
      }
    ],
  },
  {
    label: "CRM",
    separator: false,
    module: "CRM",
    imgsrc: "assets/img/crm.png",
    children: [
      {
        label: "Customer",
        separator: false,
        module: PermissionKey.CRM_CUSTOMER_MODULE,
        route: "/masters/crm/customer",
      },
      {
        label: "Enquiry",
        seperator: false,
        module: PermissionKey.ENQUIRY_MODULE,
        route: "/masters/crm/enquiry",
      },
    ],
  },
  {
    label: "DOCUMENT",
    separator: false,
    module: "DOCUMENT",
    route: "masters/document",
    imgsrc: "assets/img/bl.png"
  },

  {label:'ACCOUNTS',separator:true,module:'ACCOUNT'},
  {
    label:'GROUP',
    module:'GROUP',
    separator:false,
    route:'/accounts/group',
    imgsrc: "assets/img/group.png",
  },
  {
    label:'LEDGER',
    module:'LEDGER',
    separator:false,
    imgsrc: "assets/img/ledger.png",
    route:'accounts/ledger'
  },
  
  { label: "TRANSACTIONS", separator: true },
  {
    label: "TARIFFS",
    separator: false,
    module : "TARIFFS",
    imgsrc: "assets/img/tariff.png",
    children: [
      {
        label: "FCL Margin",
        separator: false,
        module: "FCL MARGIN",
        route: "/transactions/tariffs/fcl-margin",
      },
      {
        label: "Container Freight",
        separator: false,
        module: "CONTAINER FREIGHT",
        route: "/transactions/tariffs/container-freight",
      },
      // {
      //   label: "Container Booking",
      //   separator: false,
      //   module: "CONTAINER BOOKING",
      //   route: "/transactions/tariffs/container-booking",
      // },
      {
        label: "LCL Tariff",
        separator: false,
        module: "LCL TARIFF",
        route: "/transactions/tariffs/lcl-tariff",
      },
      {
        label: "Send Tariff Dashboard",
        seperator: false,
        module: "SEND TARIFF DASHBOARD",
        route: "/transactions/tariffs/send-tariff-dashboard",
      }
    ]
  },
  {
    label: "CARTING",
    separator: false,
    module : "CARTING",
    imgsrc: "assets/img/cart.png",
    children: [
      // {
      //   label: "LCL House/Cargo",
      //   separator: false,
      //   module: "LCL HOUSE",
      //   route: "/transactions/carting/lcl-house",
      // },
      // {
      //   label: "FCL Only Stuffing",
      //   separator: false,
      //   module: "FCL ONLY STUFFING",
      //   route: "/transactions/carting/fcl-only-stuffing",
      // },
      // {
      //   label: "Air Export",
      //   separator: false,
      //   module: PermissionKey.AIR_EXPORT,
      //   route: "/transactions/carting/air-export",
      // },
      // {
      //   label: "Air Import",
      //   separator: false,
      //   module: PermissionKey.AIR_IMPORT,
      //   route: "/transactions/carting/air-import",
      // },
      // {
      //   label: "Buyers Consol House/Cargo",
      //   separator: false,
      //   module: PermissionKey.BUYERS_CONSOL_HOUSE,
      //   route: "/transactions/carting/buyers-consol-house",
      // },
      // {
      //   label: "LCL Inter CFS",
      //   separator: false,
      //   module: PermissionKey.LCL_INTER_CFS,
      //   route: "/transactions/carting/lcl-inter-cfs",
      // },
      {
        label: "Shipping Bill",
        separator: false,
        module: PermissionKey.SHIPPING_BILL,
        route: "/transactions/carting/shipping-bill",
      },
      // {
      //   label: "CFS Shipping Bill",
      //   separator: false,
      //   module: PermissionKey.CFS_SHIPPING_BILL,
      //   route: "/transactions/carting/cfs-shipping-bill",
      // },
      // {
      //   label: "Factory Shipping Bill",
      //   separator: false,
      //   module: PermissionKey.FACTORY_SHIPPING_BILL,
      //   route: "/transactions/carting/factory-shipping-bill",
      // },
      // {
      //   label: "Hub Shipping Bill",
      //   separator: false,
      //   module: PermissionKey.HUB_SHIPPING_BILL,
      //   route: "/transactions/carting/hub-shipping-bill",
      // },
      {
        label: "Cargo Pool",
        separator: false,
        module: PermissionKey.CARGO_POOL,
        route: "/transactions/carting/cargo-pool",
      },
    ],
  },
  {
    label: "PRE STUFFING",
    separator: false,
    module : "PRESTUFFING",
    imgsrc: "assets/img/prestuff.png",
    children: [
      {
        label: "Pre Stuffing Window",
        separator: false,
        module: PermissionKey.PRE_STUFFING_WINDOW,
        route: "/transactions/pre-stuffing/pre-stuffing-window",
      },
    ],
  },
  {
    label: "BL",
    separator: false,
    module : "BL",
    imgsrc: "assets/img/bl.png",
    children: [
      {
        label: "Generate BL Home",
        separator: false,
        module: PermissionKey.BL,
        route: "/transactions/BL/generate",
      },
      {
        label: "BL Home",
        separator: false,
        module: PermissionKey.BL,
        route: "/transactions/BL/home",
      },
    ],
  },
  {
    label: "POST STUFFING",
    separator: false,
    module : "POST STUFFING",
    imgsrc: "assets/img/poststuff.png",
    children: [
      {
        label: "Post Stuffing Window",
        separator: false,
        module: PermissionKey.POST_STUFFING_WINDOW,
        route: "/transactions/post-stuffing/post-stuffing-window",
      },
    ],
  },
  {
    label: "CS HOME",
    separator: false,
    module : "CS Home",
    imgsrc: "assets/img/cs.png",
    children: [
      {
        label: "CS Home Window",
        separator: false,
        module: PermissionKey.CS_HOME_WINDOW,
        route: "/transactions/cs-home/cs-home-window",
      },
      {
        label: "Service Requirement",
        separator: false,
        module: PermissionKey.SERVICE_REQUIREMENT_MODULE,
        route: "/transactions/cs-home/service-requirement",
      },
      {
        label: "Cargo Management",
        seperator: false,
        module: PermissionKey.CARGO_MANAGEMENT_PROCESS,
        route: "/transactions/cs-home/cs-home-window/cargo-management",

      },
    ],
  },
  {
    label: "MBL Home",
    separator: false,
    module : "MBL Home",
    imgsrc: "assets/img/bl.png",
    children: [
      {
        label: "MBL Home Window",
        separator: false,
        module: PermissionKey.MBL_HOME_WINDOW,
        route: "/transactions/mbl-home/mbl-home-window",
      },
    ],
  },
  { label: "REPORTS", separator: true },
  {
    label: "REPORTS",
    separator: false,
    module : "REPORTS",
    imgsrc: "assets/img/bl.png",
    children: [
      {
        label: "Operational Reports",
        separator: false,
        module: PermissionKey.OPERATIONAL_REPORTS,
        route: "/reports/operational",
      },

    ]
  },
  { label: "TRACKING DETAILS", separator: true },
  {
    label: "TRACKING DETAILS",
    separator: false,
    module : "Tracking Details",
    imgsrc: "assets/img/poststuff.png",
    children: [
      {
        label: "Container Tracking Window",
        separator: false,
        module: PermissionKey.CONTAINER_TRACKING_WINDOW,
        route: "/transactions/container-tracking/container-tracking-window",
      },
      // {
      //   label: "Consol Cargo Tracking Window",
      //   separator: false,
      //   module: PermissionKey.CONSOL_CARGO_TRACKING_WINDOW,
      //   route: "/transactions/container-tracking/consol-cargo-tracking-window",
      // },

    ]
  },
  { label: "TRACKING OUTPUT", separator: true },
  {
    label: "TRACKING OUTPUT",
    separator: false,
    module : "Tracking Output",
    imgsrc: "assets/img/location.png",
    children: [
      {
        label: "Open Tracking Output",
        separator: false,
        module: TrackingOutputModuleName.OPEN_TRACKING_MODULE,
        route: "/tracking-output/open-tracking",
      },
    ]
  },


  // { label: 'OPERATIONAL TRANSACTION', separator: true },
  // {
  //     label: 'Cargo Carting', route: '/operational-trns/cargo-carting',
  //     imgsrc: 'assets/img/cargo_casting_icon.png',
  //     separator: false,
  // },
  // {
  //     label: 'Cargo Ready', route: '/operational-trns/cargo-ready',
  //     imgsrc: 'assets/img/cargo_ready_icon.png',
  //     separator: false,
  // },

  // { label: 'INSTANT TRANSACTIONS', separator: true },
  // {
  //     label: 'Bank Book', iconClasses: '',separator: false,
  //     imgsrc: 'assets/img/bank_book_icon.png',
  //     children: [
  //         { label: 'Bank Receipt', route: '/instant-trns/bank-book/bank-receipt' }
  //     ],

  // },
  // {
  //     label: 'Cash Book', route: '/instant-trns/cash-book',
  //     imgsrc: 'assets/img/cash_book_icon.png',
  //     separator: false,
  // },

  // { label: 'REPORTS', separator: true },
  // {
  //     label: 'Sales', iconClasses: '',separator: false,
  //     imgsrc: 'assets/img/sales_icon.png',
  //     children: [
  //         { label: 'CMB wise cargo', route: '/report/sales/cmb-wise-cargo' }
  //     ],
  // },
  // { label: 'MIS', separator: true },
  // {
  //     label: 'MIS 1', route: '/mis/mis1',separator: false,
  //     imgsrc: 'assets/img/mis_1_icon.png',
  // },
  // {
  //     label: 'MIS 2', route: '/mis/mis2',separator: false,
  //     imgsrc: 'assets/img/mis_2_icon.png',
  // },

  // { label: 'DEADLINES', separator: true },
  // {
  //     label: 'Monthly GST', route: '/deallines/monthlygst',separator: false,
  //     imgsrc: 'assets/img/monthly_gst_icon.png',
  // },
  // {
  //     label: 'Quater GST', route: '/deallines/quatergst',separator: false,
  //     imgsrc: 'assets/img/quaterly_gst_icon.png',
  // },
  // {
  //     label: 'Six Monthly GST', route: '/deallines/sixmonthlygst',separator: false,
  //     imgsrc: 'assets/img/six_monthly_gst_icon.png',
  // },
  // {
  //     label: 'Annual GST', route: '/deallines/annualgst',separator: false,
  //     imgsrc: 'assets/img/annual_gst_icon.png',
  // },
  // {
  //     label: 'TDS', route: '/deallines/tds',separator: false,
  //     imgsrc: 'assets/img/tds_icon.png',
  // },

  // { label: 'SETTINGS', separator: true },
  // {
  //     label: 'Privacy Security', route: '/setting/privacy_security',separator: false,
  //     imgsrc: 'assets/img/security_icon.png',
  // },
  // {
  //     label: 'Language', route: '/setting/language',separator: false,
  //     imgsrc: 'assets/img/language_icon.png',
  // },
  // {
  //     label: 'System', route: '/setting/system',separator: false,
  //     imgsrc: 'assets/img/security_icon.png',
  // },
];
